module.exports = __webpack_public_path__ + "static/media/logo.0ff45e2f.svg";